import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { useLocation } from "react-router";
import styled from "styled-components";
import hexToRgba from "hex-to-rgba";

import { Box, Breadcrum, Card, Flex, Grid, Text } from "atoms";

const BoxStyle = styled(Box)`
  .accordion__item {
    margin-bottom: 2rem;
  }
  .accordion__button {
    padding: 0;
    position: relative;
    border-radius: 2rem;
  }
  .accordion__button::before {
    position: absolute !important;
    right: 5rem;
    top: 2.5rem;
    color: white;
    z-index: 1;
  }

  @media only screen and (max-width: 600px) {
    .accordion__button::before {
      position: absolute;
      right: 2rem;
      top: 2.5rem;
    }
    .accordion__button p {
      font-size: 1.4rem;
    }
  }
`;

const UserActivity = () => {
  const location = useLocation();
  return (
    <BoxStyle>
      <Breadcrum
        firstText="settings"
        secondText="activity-log"
        thirdText={location.pathname.replace("/setting/activity-log/", "").replace("-", " ")}
      />

      <Card my="2.4rem">
        <Box>
          <Box
            height="92%"
            width="1px"
            bg="neutral.100"
            position="absolute"
            top="2rem"
            bottom="4.4rem"
          />
          <Accordion allowZeroExpanded={true}>
            {[0, 1, 2, 3, 4].map((index) => (
              <AccordionItem key={index}>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <Grid gridAutoFlow="column" justifyContent="space-between" py="1.2rem">
                      <Flex alignItems="center">
                        <Box
                          height=".8rem"
                          width=".8rem"
                          borderRadius="100%"
                          bg="neutral.600"
                          mr="1.2rem"
                        />
                        <Text
                          fontSize="1.4rem"
                          color="neutral.500"
                          fontFamily="NeometricRegular"
                          width="10rem"
                        >
                          Oct 17
                        </Text>
                        <Text fontSize="1.4rem" color="neutral.800" fontFamily="NeometricMedium">
                          Raj Malhotra{" "}
                          <Text as="span" color="primary.900" fontFamily="NeometricBold">
                            viewed
                          </Text>{" "}
                          document
                        </Text>
                      </Flex>
                      <Text fontSize="1.4rem" color="neutral.800" fontFamily="NeometricRegular">
                        Oct 17
                      </Text>
                    </Grid>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Card ml="12rem" bg={hexToRgba("#FDF2E0", 0.5)}>
                    <Text fontSize="1.4rem" color="primary.900" fontFamily="NeometricRegular">
                      Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.
                      Velit officia consequat duis enim velit mollit. Exercitation veniam.
                    </Text>
                  </Card>
                </AccordionItemPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      </Card>
    </BoxStyle>
  );
};

export default UserActivity;
